
define('text!modules/creatives/video/templates/classification.html',[],function () { return '<div class="classification check-radio-forms">\n    <creatives-classification-assignment id="creativeAssignments" fitparent unresolved></creatives-classification-assignment>\n</div>\n{{>footer}}';});

